import PropTypes from 'prop-types';

class Plan {
  static get TYPE() {
    return 'plan';
  }

  static get TYPE_GOAL_BASED() {
    return 'goalBased';
  }

  static get TYPE_EDUCATION() {
    return 'education';
  }

  static get TYPE_RETIREMENT() {
    return 'retirement';
  }

  static fromAPIResponse(res) {
    if (res.type !== Plan.TYPE) {
      return new Plan();
    }
    return Object.assign(new Plan(), res.attributes, {
      id: res.id,
      templates: res.templates,
    });
  }

  constructor() {
    this.id = 0;
    this.householdID = 0;
    this.type = '';
    this.externalPlanType = '';
    this.externalPlanLabel = '';
    this.planName = '';
    this.lastModified = new Date().getTime();
    this.url = '';
    this.templates = [];
  }
}

export default Plan;

export const extendablePropTypes = {
  id: PropTypes.number.isRequired,
  householdID: PropTypes.number.isRequired,
  type: PropTypes.oneOf([
    '',
    'education',
    'goalBased',
    'retirement',
    'external',
    'retirementIncome',
    'debt',
    'investmentProposal',
    'mortgageLoanComparison',
    'mortgageRefinance',
    'mortgageAcceleration',
    'resourceAllocation',
    'lifeInsurance',
  ]).isRequired,
  planName: PropTypes.string.isRequired,
  externalPlanType: PropTypes.string,
  externalPlanLabel: PropTypes.string,
};

export const propTypes = PropTypes.shape(extendablePropTypes);
